import { ProspectDto } from '@zaplify/prospects';
import { apiEndpoint, getZaplifySdk } from '@zaplify/sdk';
import { useProspectCollections } from './use-prospect-collections';
import { useMsal } from '@azure/msal-react';

export const useProspects = () => {
    const { prospectCollections } = useProspectCollections();
    const msal = useMsal();
    const prospectsSdk = getZaplifySdk(apiEndpoint, msal.instance).profiles.prospects;

    const getProspects = async ({
        searchTerm,
        userOrganizationId,
        page,
        pageSize,
        prospectCollectionId,
    }: {
        searchTerm?: string;
        userOrganizationId: string;
        page: number;
        pageSize: number;
        prospectCollectionId?: string;
    }): Promise<{ prospects: ProspectDto[]; count: number }> => {
        const filteredProspectIds = prospectCollectionId
            ? prospectCollections.find((pc) => pc.id === prospectCollectionId)?.prospectIds || []
            : [];
        const matchedProspects = await prospectsSdk.searchProspectIds({
            prospectIds: filteredProspectIds,
            organizationId: userOrganizationId,
            regex: [searchTerm ?? ''],
            sort: { 'data.fullName': 1 },
            page: page,
            perPage: pageSize,
        });
        if (!matchedProspects.prospects) return { prospects: [], count: 0 };

        const prospects = matchedProspects.prospects;
        return { prospects, count: matchedProspects.prospectsCount };
    };

    return { getProspects };
};
